export default "__VITE_ASSET__1fc049ec__"